export enum AssignedNominationStatus {
  Assigned = 'Assigned',
  NoneAvailable = 'NoneAvailable',
  JudgingComplete = 'JudgingComplete',
}

export type NominationIdRef =
  | { status: AssignedNominationStatus.Assigned; nominationId: number }
  | { status: AssignedNominationStatus.NoneAvailable }
  | { status: AssignedNominationStatus.JudgingComplete };
